<template>
  <div class="singprize" id="signprize">
    <div class="box">
      <ul class="luck-draw">
        <li v-for="(item, index) in drawList" :key="index" :class="{ active: index == current }">
          <img :src="item.src" alt />
        </li>
      </ul>
      <!-- 抽奖状态 -->
      <div class="status" v-if="signPrizeStatus < 2">
        <!-- 按钮 -->
        <div class="btn">
          <button class="btn1">抽奖未开始</button>
        </div>
      </div>

      <div class="status" v-if="signPrizeStatus == 2">
        <!-- 活动进行中 -->
        <!-- 已登录 -->
        <div v-if="isLogin">
          <!-- 按钮 -->
          <div class="btn">
            <button class="btn2" @click="isPopShow = true" :disabled="disabled">
              <a href="#signprize">点击抽奖2</a>
            </button>
            <!-- <button class="btn4" @click="toDrawHistory">抽奖记录</button> -->
          </div>
        </div>

        <!-- 未登录 -->
        <div v-else>
          <!-- 按钮 -->
          <div class="btn">
            <button class="btn1" @click="login">点击抽奖</button>
            <!-- <button class="btn4" @click="toDrawHistory">抽奖记录</button> -->
          </div>
        </div>
      </div>
      <!-- 活动已结束 -->
      <div class="status" v-if="signPrizeStatus > 2">
        <div class="btn">
          <button class="btn3">点击抽奖</button>
          <!-- <button class="btn4" @click="toDrawHistory">抽奖记录</button> -->
        </div>
      </div>

      <!--中奖纪录 -->
      <div class="zjjl">
        <span @click="toDrawHistory">中奖记录</span>
      </div>
      <!-- 抽奖说明 -->
      <div class="cjsm">
        <router-link to="/explain">
          <span>抽奖说明</span>
        </router-link>
      </div>

      <!-- 中奖展示 -->
      <div class="show-draw">
        <swiper class="swiper-container swiper draw1-swiper" v-if="list.length != 0" :options="swiperOptions" ref="mySwiper">
          <swiper-slide class="swiper-slide" v-for="(item, index) in list" :key="index">{{ `${item.mobile}抽中${item.prize}` }}</swiper-slide>
        </swiper>

        <div v-else>
          <div class="line" style="text-align: center;">暂无中奖记录</div>
        </div>
        <!-- <router-link to="/explain">抽奖说明</router-link> -->
      </div>
    </div>

    <!-- 底部 -->
    <Footer />

    <!-- 抽中奖品(中奖展示弹窗) -->
    <div class="tc-bg" v-if="popShow">
      <div class="tc">
        <img class="close" src="@/assets/images/close.png" @click="popShow = false" />
        <img class="qycj_succ_dh" src="@/assets/images/qycj_succ_dh.png" />
        <h4>恭喜您抽中</h4>
        <h6>{{ drawList[current].Title }}</h6>
        <p>我们会核实您的签约状态并在5个工作日内以短信形式确认您的中奖信息。欢迎咨询您的留学规划顾问了解兑奖流程。</p>
      </div>
    </div>

    <div class="drawinfo" v-if="isPopShow">
      <div class="draw-pop"></div>
      <div class="draw-from">
        <div class="form">
          <input type="text" class="code" id="cj-code" v-model="qyFormData.code" ref="code" autocomplete="off" maxlength="18" />
          <input type="number" class="phone" id="phone" v-model="qyFormData.mobile" ref="mobile" autocomplete="off" oninput="if(value.length>11)value=value.slice(0,11)" />

          <p class="select" @click="select">{{ qyFormData.city ? qyFormData.city : "请选择" }}</p>
          <div class="pop-btn">
            <a class="btn-qx" @click="isPopShow = false">取消</a>
            <button class="btn-qd" @click="getQyPrize">确定</button>
          </div>
        </div>

        <!-- 下拉选项框 -->
        <ul class="option" v-show="qycjCityData.iShow">
          <li v-for="(item, index) in qycjCityData.cityList" :key="index" @click="cikOption(item.T_Name)">{{ item.T_Name }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getSignPrize, getSignPrizeInfoList, baseUrl } from "@/api/home";
import Footer from "../../components/footer.vue";

export default {
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
    // 抽奖状态
    signPrizeStatus: {
      type: Number,
    },
    expoId: {
      type: Number,
      default: 0,
    },
  },
  components: { Footer },
  data() {
    return {
      popShow: false,
      //奖品列表
      current: -1,
      drawList: [
        {
          Id: 194,
          Title: "苹果iPadPro12.9",
          src: require("@/assets/images/draw2_img1.png"),
        },
        {
          Id: 195,
          Title: "国行NintendoSwitch",
          src: require("@/assets/images/draw2_img2.png"),
        },
        {
          Id: 196,
          Title: "华为智能手表",
          src: require("@/assets/images/draw2_img3.png"),
        },
        {
          Id: 198,
          Title: "小米旅行箱20寸",
          src: require("@/assets/images/draw2_img4.png"),
        },
        {
          Id: 200,
          Title: "小米加湿器",
          src: require("@/assets/images/draw2_img5.png"),
        },
        {
          Id: 199,
          Title: "小米水离子吹风机",
          src: require("@/assets/images/draw2_img6.png"),
        },
        {
          Id: 200,
          Title: "小米加湿器",
          src: require("@/assets/images/draw2_img7.png"),
        },
        {
          Id: 197,
          Title: "华为运动耳机",
          src: require("@/assets/images/draw2_img8.png"),
        },
      ],
      time: "",
      speed: "",
      diff: "",
      award: {
        id: "",
        name: "",
      }, // 抽中的奖品
      qyFormData: {
        code: "", // 抽奖码
        mobile: "", // 手机号
        city: "", // 签约分公司
        isDisable: false,
      },
      // 城市列表和状态展示
      qycjCityData: {
        iShow: false,
        cityList: [], //城市列表数据
      },
      list: [],
      swiperOptions: {
        slidesPerView: 1, //显示多少条
        spaceBetween: 5, //每条之间间隔
        autoplay: {
          delay: 2000,
        },
        // direction: "vertical",
        // autoHeight: true,
      },
      timeStatus: 0,
      timeout: null,
      statusSwitchShow: false, //下拉框箭头状态
      disabled: false,
      isPopShow: false,
    };
  },
  computed: {},
  methods: {
    // 点击箭头展示隐藏
    select() {
      this.qycjCityData.iShow = !this.qycjCityData.iShow;
    },
    // 点击选择城市
    cikOption(city) {
      this.qyFormData.city = city;
      //console.log(city);
      this.qycjCityData.iShow = false;
    },
    // 获取城市列表
    getCityList() {
      this.$axios
        .get("https://cmsapi.eiceducation.com.cn/api/CmsFiliales/GetFilialesList")
        .then((res) => {
          if (!res.data.succ) {
          } else {
            this.qycjCityData.cityList = res.data.results;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //点击开始
    start() {
      this.move();
      this.time = Date.now();
      this.speed = 150;
      this.diff = 15;
    },

    move() {
      this.timeout = setTimeout(() => {
        this.current++;
        if (this.current >= this.drawList.length) {
          this.current = 0;
        }

        // 若抽中的奖品id存在，则开始减速转动(6代表中间部分 转动时间)
        if (this.award.id && (Date.now() - this.time) / 1000 > 2) {
          this.speed += this.diff; // 转动减速

          // 若转动时间超过4秒，并且奖品id等于小格子的奖品id，则停下来！
          if (
            (Date.now() - this.time) / 1000 > 6 &&
            this.award.id == this.drawList[this.current].Id
          ) {
            //console.log(1231321321)
            clearTimeout(this.timeout);
            //抽中奖品
            this.popShow = true;
            this.disabled = false; //开始抽奖按钮可以点击
            return;
          }
          // 若抽中的奖品不存在，则加速转动
        } else {
          this.speed -= this.diff; // 转动加速
        }

        this.move();
      }, this.speed);
    },

    login() {
      if (!this.isLogin) {
        this.$emit("showLogin", "signprizeBtn");
        return false;
      }
    },

    //提交表单，获取签约抽奖奖品
    async getQyPrize() {
      let that = this;
      let phoneTel = that.qyFormData.mobile;
      let code = that.qyFormData.code;
      let city = that.qyFormData.city;
      //console.log(phoneTel, code, city);
      let telPartton = /^1\d{10}$/;
      // 判断是否登录
      if (!this.isLogin) {
        this.$emit("showLogin", "signprizeBtn");
        return false;
      }

      if (code == "") {
        setTimeout(() => {
          alert("抽奖码必须填写");
        }, 100);
        that.$refs.code.focus();
        return false;
      }
      if (phoneTel == "" || phoneTel == "请输入手机号") {
        setTimeout(() => {
          alert("请输入您的手机号！");
        }, 100);
        that.$refs.mobile.focus();
        return false;
      }

      if (!telPartton.test(phoneTel)) {
        setTimeout(() => {
          alert("手机号码格式不正确");
        }, 100);
        that.$refs.mobile.focus();
        return false;
      }

      if (!city) {
        setTimeout(() => {
          alert("请选择签约分公司");
        }, 100);
        return false;
      }
      this.isPopShow = false;
      this.disabled = true; //开始抽奖按钮不能点击

      const res = await getSignPrize({
        city,
        code,
        mobile: phoneTel,
        expoId: this.expoId,
      });
      //console.log(res);
      if (!res.succ) {
        alert(res.msg);
        this.disabled = false; //开始抽奖按钮可以点击
      } else {
        this.award.id = res.results.Id;
        // this.award.id = 76;
        this.award.name = res.results.Title;
        this.start();
      }
    },

    // 获取抽奖详情
    async getInfoList() {
      const res = await getSignPrizeInfoList({
        params: {
          expoId: this.expoId,
        },
      });
      //console.log('res', res)
      this.list = res.results;
    },

    // 点击跳转抽奖记录页面
    toDrawHistory() {
      let signPrizeStatus = this.signPrizeStatus;
      if (!this.isLogin) {
        this.$emit("showLogin", "signprize");
        return;
      }
      if (signPrizeStatus < 2) {
        // 抽奖未开始
        alert("抽奖未开始");
        return;
      }
      //抽奖期间
      window.location.href = `${baseUrl}/user/draw_record`;
    },
  },
  created() {
    if (this.expoId) {
      this.getCityList();
      this.getInfoList();
    }
  },
  watch: {
    // 签约抽奖时间状态
    signPrizeStatus(newVal) {
      this.signPrizeStatus = newVal;
    },
    expoId(newVal) {
      if (newVal) {
        this.getCityList();
        this.getInfoList();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.singprize {
  width: 100%;
  position: relative;
  .box {
    background: url(~@/assets/images/draw2_bg.png) no-repeat;
    background-size: 100% auto;
    min-height: 11rem;
    position: relative;
    // margin: 0 0.26rem;
    h3 {
      font-size: 0.34rem;
      font-weight: 900;
      color: #fff;
      text-indent: -999px;
      padding: 0.2rem 0;
      text-align: center;
    }
    .luck-draw {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      // padding: 3rem 0.6rem 0;
      height: 11rem;
      li {
        display: block;
        overflow: hidden;
        // border: 0.04rem solid #e3e3e3;
        // border-radius: 0.2rem;
        width: 1.72rem;
        height: 1.72rem;
        text-align: center;
        // background: #fff;
        margin-bottom: 0.13rem;
        position: absolute;
        &.active {
          border: 0.1rem solid #ffca14;
          border-radius: 0.28rem;
        }
        &:nth-child(1) {
          top: 2.85rem;
          left: 1rem;
        }
        &:nth-child(2) {
          top: 2.85rem;
          left: 2.87rem;
        }
        &:nth-child(3) {
          top: 2.85rem;
          left: 4.75rem;
        }
        &:nth-child(4) {
          top: 4.72rem;
          left: 4.75rem;
        }
        &:nth-child(5) {
          top: 6.57rem;
          left: 4.75rem;
        }

        &:nth-child(6) {
          top: 6.57rem;
          left: 2.87rem;
        }
        &:nth-child(7) {
          top: 6.57rem;
          left: 1rem;
        }
        &:nth-child(8) {
          top: 4.72rem;
          left: 1rem;
        }
      }
    }

    // 活动状态
    .status-con {
      width: 100%;
      position: absolute;
      top: 2.55rem;
      left: 0;
      // left: 50%;
      // margin-left: -2.1rem;
      p {
        text-align: center;
        color: #2e58a3;
        font-size: 0.26rem;
        line-height: 0.27rem;
        font-weight: 400;
      }
      h5 {
        width: 3.8rem;
        height: 0.36rem;
        background: #fff;
        border-radius: 0.08rem;
        text-align: center;
        color: #3e546a;
        font-size: 0.22rem;
        line-height: 0.36rem;
      }
    }
    .btn {
      position: absolute;
      left: 2.87rem;
      top: 4.72rem;
      width: 1.72rem;
      height: 1.72rem;
      button {
        width: 100%;
        height: 100%;
        border: 0;
        outline: none;
        font-size: 0;
        background-color: transparent;
        &.btn1 {
          background: url(~@/assets/images/draw2_btn1.png) no-repeat;
          background-size: 100% 100%;
        }
        &.btn2 {
          background: url(~@/assets/images/draw2_btn2.png) no-repeat;
          background-size: 100% 100%;
        }
        &.btn3 {
          background: url(~@/assets/images/draw2_btn3.png) no-repeat;
          background-size: 100% 100%;
        }
      }
    }

    .zjjl {
      opacity: 0;
      position: absolute;
      top: 9.25rem;
      left: 1.35rem;
      background-color: pink;
      width: 2.07rem;
      height: 0.6rem;
    }
    .cjsm {
      opacity: 0;
      background-color: pink;
      position: absolute;
      right: 1.45rem;
      top: 9.25rem;
      width: 2.07rem;
      height: 0.6rem;
    }
  }
}

.draw-from {
  background: #ffffff;
  padding: 0.4rem;
  position: fixed;
  top: 20%;
  border: 0.04rem solid #2d66e8;
  border-radius: 0.24rem;
  z-index: 10000;
  margin: 0 0.4rem;
  .form {
    background-size: 100% 100%;
    position: relative;
    input {
      border: 0;
      height: 0.5rem;
      width: 100%;
      margin-bottom: 0.29rem;
      padding-left: 2.9rem;
      &.code {
        background: url(~@/assets/images/draw2_form1.jpg) no-repeat;
        background-size: 100% 100%;
      }
      &.phone {
        background: url(~@/assets/images/draw2_form2.jpg) no-repeat;
        background-size: 100% 100%;
      }
    }

    p {
      width: 100%;
      height: 0.5rem;
      line-height: 0.5rem;
      border: 0;
      background-color: #fff;
      background: url(~@/assets/images/draw2_form3.jpg) no-repeat;
      background-size: 100% 100%;
      padding-left: 2.9rem;
      font-size: 0.28rem;
    }
    img {
      width: 0.28rem;
      height: 0.23rem;
      position: absolute;
      right: 0.35rem;
      bottom: 0.14rem;
    }
  }
  ul {
    &.option {
      width: 3.3rem;
      height: 3rem;
      overflow: auto;
      background-color: #fff;
      padding: 0.1rem 0;
      position: absolute;
      right: 0.42rem;
      top: 2.5rem;
      z-index: 99;
      border: 0.01rem solid #2d66e8;
      li {
        height: 0.5rem;
        line-height: 0.5rem;
        padding: 0 0.2rem;
        font-size: 0.22rem;
        &:hover {
          background-color: #efefef;
        }
      }
    }
  }
  .pop-btn {
    text-align: center;
    padding-top: 0.58rem;
    .btn-qx {
      width: 1.8rem;
      height: 0.54rem;
      background: rgba(198, 225, 250, 1);
      font-size: 0.24rem;
      line-height: 0.54rem;
      display: inline-block;
      border-radius: 0.27rem;
      margin-right: 0.41rem;
      color: #0475df;
      letter-spacing: 0.06rem;
      font-weight: bold;
      vertical-align: top;
    }
    .btn-qd {
      width: 1.8rem;
      height: 0.54rem;
      background: #0475df;
      font-size: 0.24rem;
      display: inline-block;
      border-radius: 0.27rem;
      margin-right: 0.41rem;
      color: #fff;
      letter-spacing: 0.06rem;
      font-weight: bold;
      border: 0;
      vertical-align: top;
    }
  }
}
.draw-pop {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: #000;
  opacity: 0.7;
  z-index: 9999;
}

// 中奖弹窗
.tc-bg {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  .tc {
    width: 6.2rem;
    height: 3.58rem;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    padding: 0.1rem 0.3rem 0;
    border-radius: 0.2rem;
    text-align: center;
    border: 0.02rem solid #2d66e8;
    .close {
      width: 0.32rem;
      height: 0.28rem;
      position: absolute;
      right: 0;
      top: 0;
    }
    .qycj_succ_dh {
      width: 0.7rem;
      height: 0.7rem;
      display: block;
      margin: 0 auto 0.24rem;
    }
    h4 {
      font-size: 0.4rem;
    }
    h6 {
      color: #2d66e8;
      font-weight: 900;
      font-size: 0.3rem;
      padding: 0.1rem 0;
    }
    p {
      font-size: 0.26rem;
      padding-top: 0.1rem;
    }
  }
}
.show-draw {
  position: absolute;
  top: 2.28rem;
  font-size: 0.22rem;
  color: #ffffff;
  text-align: center;
  width: 4.5rem;
  left: 1.5rem;
}

// .show-draw .swiper-container {
//   width: 4.6rem;
//   height: 1.45rem;
//   margin: 0.85rem auto;
// }
.show-draw .swiper-slide {
  // text-align: center;
  overflow: hidden;
  // text-overflow: ellipsis;
  white-space: nowrap;
  // padding: 0 0.5rem;
  // font-size: 0.2rem;
  // font-weight: 400;
  // line-height: 0.22rem;
}
</style>